import { createFileRoute } from '@tanstack/react-router';
import { HabitHistory } from '../../../components/habits/habit-history';

export const Route = createFileRoute('/habits/$habitId/history')({
  component: HabitHistory,
});
